export function formateClientsByGroupTree(data) {
    data.forEach(function (item, index) {
        item.supplier_to_business_id = "group" + index;
        item.business_name = item.group_name;
        item.nodeType = 'business_group';
        item.children.forEach(function (leaf, leafIndex) {
            leaf.nodeType = 'business';
            leaf.group_id = item.group_id;
            leaf.children = leaf.shops || [];
            leaf.children.forEach(function (shop) {
                shop.nodeType = 'shop';
                shop.business_name = shop.shop_name;
                shop.supplier_to_business_id = shop.shop_id + '_' + leaf.supplier_to_business_id + '_' + leaf.business_id;
                shop.parent_supplier_to_business_id = leaf.supplier_to_business_id;
                shop.parent_parent_supplier_to_business_id = item.supplier_to_business_id;
            });
        });
    });
    return data;
}
export function initClientsRight(treeDataLevel2, supplier_to_business_ids, group_ids, shop_ids, business_ids) {
    console.log(333, treeDataLevel2, supplier_to_business_ids);
    treeDataLevel2.forEach(function (v) {
        var chkChildrensNum = 0;
        v.children.forEach(function (leaf) {
            var isChk = supplier_to_business_ids.includes(leaf.supplier_to_business_id);
            leaf.isChk = isChk;
            chkChildrensNum = chkChildrensNum + (isChk ? 1 : 0);
            console.log('business_ids', business_ids);
            if (business_ids && business_ids.length > 0) {
                var result = business_ids.filter(function (business_item) { return business_item.business_id == leaf.business_id && business_item.supplier_to_business_id == leaf.supplier_to_business_id; });
                console.log('result', result);
                if (result.length > 0) {
                    leaf.is_set_group = 3;
                }
                else {
                    leaf.is_set_group = 4;
                }
            }
            if (leaf.children && leaf.children.length > 0) {
                var chkShopsNum_1 = 0;
                leaf.children.forEach(function (shop) {
                    var isTempShopChecked = false;
                    isTempShopChecked = supplier_to_business_ids.includes(shop.supplier_to_business_id);
                    var isShopChecked = leaf.isChk || isTempShopChecked;
                    shop.isChk = isShopChecked;
                    shop.parent_supplier_to_business_id = leaf.supplier_to_business_id;
                    chkShopsNum_1 += shop.isChk ? 1 : 0;
                    shop.nodeType = 'shop';
                });
                leaf.chkChildrensNum = chkShopsNum_1;
                if (chkShopsNum_1 != leaf.children.length) {
                    leaf.is_set_group = 4;
                }
            }
            else {
                leaf.chkChildrensNum = 0;
            }
        });
        v.chkChildrensNum = chkChildrensNum;
        if (group_ids !== undefined) {
            v.is_set_group = group_ids.includes(v.group_id) ? 1 : 2;
        }
        if (v.is_set_group && v.chkChildrensNum != v.children.length) {
            v.is_set_group = 2;
        }
        if (v.is_set_group == 1) {
            v.children.forEach(function (leaf) {
                leaf.is_set_group = 3;
            });
        }
    });
    console.log(treeDataLevel2);
    return treeDataLevel2;
}
export function fixBusinessIdsContainGroupNotHasChildren(treeDataLevel2, supplier_to_business_ids, group_ids) {
    var ids = [];
    treeDataLevel2.forEach(function (v) {
        if (v.children.length == 0 && v.is_set_group == 1) {
            ids.push(v.supplier_to_business_id);
        }
    });
    return supplier_to_business_ids.concat(ids);
}
export function checkedTempGroupData(treeDataLevel2) {
    var supplier_to_business_ids = [];
    var group_ids = [];
    treeDataLevel2.forEach(function (v) {
        if (v.is_temp == 1) {
            group_ids.push(v.group_id);
            if (v.children.length) {
                v.children.forEach(function (bus) {
                    supplier_to_business_ids.push(bus.supplier_to_business_id);
                });
            }
        }
    });
    return {
        supplier_to_business_ids: supplier_to_business_ids,
        group_ids: group_ids
    };
}
export function goodsPriceCreateResultByClientsRight(treeDataLevel2, supplier_to_business_ids) {
    var group_ids = [];
    var business_ids = [];
    var business_info = [];
    var group_names = [];
    var business_group_names = '';
    var shop_names = [];
    var businessList = [];
    treeDataLevel2.forEach(function (v) {
        var chkChildrens = v.children.filter(function (leaf) { return leaf.isChk; });
        var businessChildren = [];
        v.children.forEach(function (leaf) {
            if (leaf.is_set_group === 3 && leaf.isChk && leaf.business_id) {
                business_ids.push({
                    business_id: leaf.business_id,
                    supplier_to_business_id: leaf.supplier_to_business_id
                });
            }
            var selectedShops = leaf.children && leaf.children.length > 0
                ? leaf.children.filter(function (shop) { return shop.isChk; })
                : [];
            var selectedShopNames = leaf.children && leaf.children.length > 0
                ? leaf.children.filter(function (shop) { return shop.isChk; }).map(function (shop) { return leaf.business_name + '-' + shop.shop_name; })
                : [];
            shop_names = shop_names.concat(selectedShopNames);
            if (selectedShops.length !== 0) {
                var selectedShopsIds = selectedShops.map(function (shop) { return shop.shop_id; });
                businessChildren.push({
                    business_id: leaf.business_id || parseInt(leaf.supplier_to_business_id),
                    supplier_to_business_id: leaf.supplier_to_business_id,
                    is_set_group: leaf.is_set_group,
                    shop_id: selectedShopsIds
                });
            }
            if (leaf.isChk && leaf.business_id && leaf.shops.length === 0) {
                businessChildren.push({
                    business_id: leaf.business_id || parseInt(leaf.supplier_to_business_id),
                    supplier_to_business_id: leaf.supplier_to_business_id,
                    is_set_group: leaf.is_set_group,
                    shop_id: []
                });
                shop_names.push(leaf.business_name);
            }
        });
        business_info.push({
            group_id: v.group_id,
            is_set_group: v.is_set_group,
            children: businessChildren
        });
        if (1 == v.is_set_group) {
            group_ids.push(v.group_id);
            group_names.push(v.business_name);
        }
        var chkChildrensList = chkChildrens.map(function (leaf) {
            return {
                supplier_to_business_id: leaf.supplier_to_business_id,
                business_name: leaf.business_name,
                business_no: leaf.business_no,
                business_contact: leaf.business_contact,
                group_name: v.group_name,
                group_id: v.group_id,
                is_set_group: v.is_set_group,
            };
        });
        businessList = businessList.concat(chkChildrensList);
    });
    business_group_names = shop_names.join('、');
    if (group_names.length) {
        var connector = business_group_names.length > 0 ? '、' : '';
        business_group_names = business_group_names + connector + group_names.map(function (v) { return '[' + v + ']'; }).join('、');
    }
    return {
        supplier_to_business_ids: supplier_to_business_ids,
        group_ids: group_ids,
        business_ids: business_ids,
        business_info: business_info,
        business_info_name: business_group_names,
        business_list: businessList,
    };
}
export function tidyDataBusinessInfo(cgTree, supplier_to_business_ids, group_ids, shop_ids, business_ids) {
    cgTree = formateClientsByGroupTree(cgTree);
    var rightTree = initClientsRight(cgTree, supplier_to_business_ids, group_ids, shop_ids, business_ids);
    return goodsPriceCreateResultByClientsRight(rightTree, supplier_to_business_ids);
}
